"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanLeftOverFromParent = exports.PLAN_LEFT_OVER = exports.leftOverByDelegationPlan = exports.createDeferred = void 0;
function createDeferred() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });
    return { promise, resolve: resolve, reject: reject };
}
exports.createDeferred = createDeferred;
exports.leftOverByDelegationPlan = new WeakMap();
exports.PLAN_LEFT_OVER = Symbol('PLAN_LEFT_OVER');
function getPlanLeftOverFromParent(parent) {
    if (parent != null && typeof parent === 'object') {
        return parent[exports.PLAN_LEFT_OVER];
    }
}
exports.getPlanLeftOverFromParent = getPlanLeftOverFromParent;
